// removed by extract-text-webpack-plugin
module.exports = {"component":"_2k7y8urp4jcc73rvmzrwftx522ac6nu2xm9a845js1a658ngc4wfgyaedvq1j4cjrktkujn38sq53vqujgkhsava1eec1vf37s5h6ye-styles-module-component","headerBodyBox":"_4dqj1hvhs7b1gby346kwz3bafbfhgpesgu3vk8bfn351xnhwfy97mfhpxbrwaqwwszsrndqvejqqn9ry3kqbbsf4d1k2j7rvspvgctf-styles-module-headerBodyBox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/Main/styles.module.sass
// module id = 583
// module chunks = 0